export default __webpack_public_path__ + "static/media/papajoe.92bbbf7f.jpg";